export const mockServices = [
  {
    id: 1,
    number: '01',
    title: 'Virtual Assistant Services',
    description: 'Dedicated remote professionals who integrate seamlessly with your team to handle day-to-day tasks, freeing you to focus on growth.',
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=80',
    features: ['Inbox & Calendar Management', 'Task Coordination', 'Travel Arrangements', 'Personal Assistance']
  },
  {
    id: 2,
    number: '02',
    title: 'Bookkeeping',
    description: 'Accurate, up-to-date books maintained by experienced bookkeepers. Stay on top of your finances with complete clarity and compliance.',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80',
    features: ['Daily Transaction Recording', 'Bank Reconciliation', 'Expense Tracking', 'Ledger Management']
  },
  {
    id: 3,
    number: '03',
    title: 'Accounting Services',
    description: 'Expert financial management tailored to your business. From reporting to compliance, we keep your finances precise and audit-ready.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
    features: ['Financial Reporting', 'Invoicing', 'VAT & Tax Preparation', 'Payroll Support']
  },
  {
    id: 4,
    number: '04',
    title: 'Data Entry',
    description: 'Fast, accurate data entry and management. We handle high-volume data with precision so your records stay clean and reliable.',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80',
    features: ['CRM Data Management', 'Spreadsheet Maintenance', 'Data Cleansing', 'Database Updates']
  },
  {
    id: 5,
    number: '05',
    title: 'Back Office Support',
    description: 'The engine behind your operations. We manage the essential behind-the-scenes tasks that keep your business running smoothly.',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80',
    features: ['Process Management', 'Order Processing', 'Compliance Support', 'Workflow Optimisation']
  },
  {
    id: 6,
    number: '06',
    title: 'Document Production',
    description: 'Professional document creation, formatting, and management. From reports to presentations, delivered with precision and care.',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80',
    features: ['Document Creation', 'Template Design', 'Format Conversion', 'Version Control']
  },
  {
    id: 7,
    number: '07',
    title: 'Portal Management',
    description: 'Comprehensive digital portal administration and maintenance. We ensure your online systems run smoothly, securely, and efficiently.',
    image: 'https://images.unsplash.com/photo-1531403009284-440f080d1e12?w=800&q=80',
    features: ['User Management', 'Content Updates', 'Access Control', 'System Monitoring']
  },
  {
    id: 8,
    number: '08',
    title: 'Calling Support',
    description: 'Professional telephone answering and customer service. Your business never misses an important call with our dedicated team.',
    image: 'https://images.unsplash.com/photo-1556745757-8d76bdb6984b?w=800&q=80',
    features: ['Call Handling', 'Message Taking', 'Appointment Scheduling', 'Customer Support']
  },
  {
    id: 9,
    number: '09',
    title: 'General Administrative Support',
    description: 'Complete administrative assistance for your operations. From scheduling to research, we handle the details so you can focus on growth.',
    image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=800&q=80',
    features: ['Email Management', 'Calendar Management', 'Research & Analysis', 'General Admin']
  },
  {
    id: 10,
    number: '10',
    title: 'Records Management',
    description: 'Organised, secure, and compliant management of your business records. We keep your files structured, accessible, and audit-ready at all times.',
    image: 'https://images.unsplash.com/photo-1568667256549-094345857637?w=800&q=80',
    features: ['Document Archiving', 'Secure Storage', 'Retention Scheduling', 'Compliance & Retrieval']
  }
];

export const mockCompanyInfo = {
  name: 'Flexdesk UK',
  tagline: 'Your Trusted Administrative Partner',
  description: 'Flexdesk UK is a premier administrative services provider dedicated to supporting businesses across all industries throughout the United Kingdom. With our comprehensive suite of services, we empower organizations to focus on their core competencies while we handle the essential administrative tasks that keep operations running smoothly.',
  mission: 'To deliver exceptional administrative services that drive efficiency, accuracy, and growth for businesses of all sizes.',
  stats: [
    { number: '500+', label: 'Clients Served' },
    { number: '13+', label: 'Years Experience' },
    { number: '98%', label: 'Client Satisfaction' },
    { number: '24/7', label: 'Support Available' }
  ]
};
